import { ReactComponent as Widget } from 'src/assets/svg/reported-widget.svg';
import { ReactComponent as Dialog } from 'src/assets/svg/reported-dialog.svg';
import { ReactComponent as LoudSpeaker } from 'src/assets/svg/reported-loudspeaker.svg';

import { withTranslation } from '@common/helpers';

export const cards = [
  {
    title: 'reportedByUser1.title',
    field: 'widgetUsage',
    icon: <Widget aria-hidden={true} aria-label={withTranslation('reported', 'reportedByUser1.iconsLabel')} />,
  },
  {
    title: 'reportedByUser2.title',
    field: 'totalReports',
    icon: <LoudSpeaker aria-hidden={true} aria-label={withTranslation('reported', 'reportedByUser2.iconsLabel')} />,
  },
  {
    title: 'reportedByUser3.title',
    field: 'totalFixedReports',
    icon: <Dialog aria-hidden={true} aria-label={withTranslation('reported', 'reportedByUser3.iconsLabel')} />,
  },
  {
    title: 'reportedByUser4.title',
    field: 'reportedThisWeek',
    icon: <LoudSpeaker aria-hidden={true} aria-label={withTranslation('reported', 'reportedByUser4.iconsLabel')} />,
  },
  {
    title: 'reportedByUser5.title',
    field: 'fixedReportsThisWeek',
    icon: <Dialog aria-hidden={true} aria-label={withTranslation('reported', 'reportedByUser5.iconsLabel')} />,
  },
];
